import { Box, Text } from '@rbilabs/universal-components';

import { InnerLayout } from 'components/layout/styled';

export const ProductNoteText = Text.withConfig({
  variant: 'copyTwo',
});

export const ProductComboFlowContainer = Box.withConfig({
  width: 'full',
});

export const ProductComboFlowInnerLayout = InnerLayout.withConfig({
  marginY: 0,
  paddingY: 0,
});
